import React from 'react'
import Table2 from './Table2'

class Content2 extends React.Component {
  render() {
    return (
      <div>
        <Table2 ProjectNo2={this.props.ProjectNo2} />
        <hr/>
       
      </div>
    )
  }
}

export default Content2;
